import React from "react";
import { Box } from "@mui/material";
import { classNames } from "../models/models";
import DistanceIcon from "../assets/icons/DistanceIcon";
import useTranslation from "../hooks/useTranslation";

export interface DistanceProps {
  distance?: number;
  size?: "small" | "medium";
  color?: string;
  iconColor?: string;
}

const Distance = ({
  distance,
  size = "small",
  color,
  iconColor
}: DistanceProps) => {
  const { translate } = useTranslation("marketplace");

  if (distance === null || distance === undefined) {
    return null;
  }

  const className = size === "small" ? "text-12-regular" : "text-14-regular";
  const iconStyle = size === "small" ? { width: 10, height: 10 } : { width: 16, height: 16 };

  return (
    <Box className={classNames(className, "flex items-center")} color={color}>
      <Box className="flex items-center">
        <DistanceIcon color={iconColor} iconStyle={iconStyle} />
      </Box>
      <Box className="ml-1">{translate("distanceFromYou", { distance })}</Box>
    </Box>
  );
};

export default Distance;